import { useQuery } from 'react-query'
import { fetchHboMaxOriginals } from '../services/api'

export const useHboMaxOriginals = options => {
  return useQuery('hboMaxOriginals', fetchHboMaxOriginals, options)
}
